import _objectWithoutProperties from '../../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.es.js';
import _taggedTemplateLiteral from '../../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, resetDefaultButtonStyles, media } from '@mgmresorts/wcl-styled';
import React from 'react';
import '../../Icons/icons/createIcon.es.js';
import '../../Icons/icons/AdultsOnlyIcon.es.js';
import '../../Icons/icons/AttractionsIcon.es.js';
import { BackIcon } from '../../Icons/icons/BackIcon.es.js';
import '../../Icons/icons/BarberIcon.es.js';
import '../../Icons/icons/BedIcon.es.js';
import '../../Icons/icons/BestRateGuaranteedIcon.es.js';
import '../../Icons/icons/CalendarIcon.es.js';
import '../../Icons/icons/CartIcon.es.js';
import '../../Icons/icons/ChairIcon.es.js';
import '../../Icons/icons/CheckIcon.es.js';
import '../../Icons/icons/CirqueIcon.es.js';
import '../../Icons/icons/CloseCircleFilledIcon.es.js';
import '../../Icons/icons/CloseIcon.es.js';
import '../../Icons/icons/ComedyIcon.es.js';
import '../../Icons/icons/ConcertsIcon.es.js';
import '../../Icons/icons/CouchIcon.es.js';
import '../../Icons/icons/CreditCardIcon.es.js';
import '../../Icons/icons/CulinaryIcon.es.js';
import '../../Icons/icons/DesertViewIcon.es.js';
import '../../Icons/icons/DrinkIcon.es.js';
import '../../Icons/icons/DropdownArrowIcon.es.js';
import '../../Icons/icons/EnlargeIcon.es.js';
import '../../Icons/icons/FanIcon.es.js';
import '../../Icons/icons/FilterIcon.es.js';
import '../../Icons/icons/ForwardIcon.es.js';
import '../../Icons/icons/FreeCancellationIcon.es.js';
import '../../Icons/icons/GridDisabledIcon.es.js';
import '../../Icons/icons/GridEnabledIcon.es.js';
import '../../Icons/icons/GuestsIcon.es.js';
import '../../Icons/icons/HeartIcon.es.js';
import '../../Icons/icons/HidePasswordIcon.es.js';
import '../../Icons/icons/InformationCircleIcon.es.js';
import '../../Icons/icons/ListViewIcon.es.js';
import '../../Icons/icons/LockFilledIcon.es.js';
import '../../Icons/icons/LockOutlineIcon.es.js';
import '../../Icons/icons/LongArrowIcon.es.js';
import '../../Icons/icons/LoungeChairIcon.es.js';
import '../../Icons/icons/MagicIcon.es.js';
import '../../Icons/icons/MattressIcon.es.js';
import '../../Icons/icons/MenuIcon.es.js';
import '../../Icons/icons/MinibarIcon.es.js';
import '../../Icons/icons/MinusCircleIcon.es.js';
import '../../Icons/icons/MinusIcon.es.js';
import '../../Icons/icons/MlifeIcon.es.js';
import '../../Icons/icons/PanoramicViewIcon.es.js';
import '../../Icons/icons/PasswordXIcon.es.js';
import '../../Icons/icons/PhoneIcon.es.js';
import '../../Icons/icons/PlusCircleIcon.es.js';
import '../../Icons/icons/PlusIcon.es.js';
import '../../Icons/icons/PoolIcon.es.js';
import '../../Icons/icons/ProfileIcon.es.js';
import '../../Icons/icons/RefreshIcon.es.js';
import '../../Icons/icons/SafeIcon.es.js';
import '../../Icons/icons/SearchIcon.es.js';
import '../../Icons/icons/ShowPasswordIcon.es.js';
import '../../Icons/icons/ShowerIcon.es.js';
import '../../Icons/icons/SortIcon.es.js';
import '../../Icons/icons/SpaRocksIcon.es.js';
import '../../Icons/icons/SpecialEventsIcon.es.js';
import '../../Icons/icons/Spinner.es.js';
import '../../Icons/icons/SportsIcon.es.js';
import '../../Icons/icons/SpotCalendarIcon.es.js';
import '../../Icons/icons/StripViewIcon.es.js';
import '../../Icons/icons/TvIcon.es.js';
import '../../Icons/icons/UmbrellaIcon.es.js';
import '../../Icons/icons/WarningCircleIcon.es.js';
import '../../Icons/icons/WarningTriangleFilledIcon.es.js';
import '../../Icons/icons/WarningTriangleIcon.es.js';
import '../../Icons/icons/WiFiIcon.es.js';
import '../../Icons/icons/BestRateIcon.es.js';
import '../../Icons/icons/FiveDiamondAwardIcon.es.js';
import '../../Icons/icons/ForbesTravelGuideIcon.es.js';
import '../../Icons/icons/AriaStackedIcon.es.js';
import '../../Icons/icons/BeauRivageIcon.es.js';
import '../../Icons/icons/BellagioIcon.es.js';
import '../../Icons/icons/BellagioInternationalIcon.es.js';
import '../../Icons/icons/BorgataIcon.es.js';
import '../../Icons/icons/CircusCircusIcon.es.js';
import '../../Icons/icons/DelanoIcon.es.js';
import '../../Icons/icons/ExcaliburIcon.es.js';
import '../../Icons/icons/GoldStrikeIcon.es.js';
import '../../Icons/icons/LuxorIcon.es.js';
import '../../Icons/icons/MandalyBayIcon.es.js';
import '../../Icons/icons/MGMChinaIcon.es.js';
import '../../Icons/icons/MGMDiayutaiIcon.es.js';
import '../../Icons/icons/MGMGrandDetroitIcon.es.js';
import '../../Icons/icons/MGMGrandIcon.es.js';
import '../../Icons/icons/MGMGrandSanyaIcon.es.js';
import '../../Icons/icons/MGMMacauIcon.es.js';
import '../../Icons/icons/MGMNationalHarborIcon.es.js';
import '../../Icons/icons/MGMResortIcon.es.js';
import '../../Icons/icons/MGMSpringfieldIcon.es.js';
import '../../Icons/icons/MirageIcon.es.js';
import '../../Icons/icons/MyVegasIcon.es.js';
import '../../Icons/icons/NYNYIcon.es.js';
import '../../Icons/icons/ParkMGMIcon.es.js';
import '../../Icons/icons/SignatureIcon.es.js';
import '../../Icons/icons/VdaraIcon.es.js';
import '../../Icons/icons/FacebookIcon.es.js';
import '../../Icons/icons/TwitterIcon.es.js';
import '../../Icons/icons/YouTubeIcon.es.js';
import '../../Icons/icons/PinterestIcon.es.js';
import '../../Icons/icons/InstagramIcon.es.js';
import '../../Icons/icons/PlayMGMIcon.es.js';
import '../../Icons/icons/MGMGRIResortIcon.es.js';
import { Text12 } from '../../Text/Text.es.js';

var _excluded = ["labelVisible", "Icon", "className"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
/**
 * Amount of whitespace on the left/right of the BackIcon
 */

var ICON_HORIZONTAL_PADDING = 6;
var IconButton = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin-left: -", "px;\n  margin-right: ", "px;\n  position: relative;\n  &:before {\n    content: ' ';\n    display: block;\n    position: absolute;\n    top: -5px;\n    left: -5px;\n    right: -5px;\n    bottom: -5px;\n  }\n  ", "\n  ", "\n"])), resetDefaultButtonStyles, ICON_HORIZONTAL_PADDING, -ICON_HORIZONTAL_PADDING + 20, media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    /* On md, this button has margins set in RoomBookingNavigation */\n    margin-right: ", "px;\n  "])), -ICON_HORIZONTAL_PADDING), media.xl(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    /* On xl, this button has margins set in RoomBookingNavigation */\n    margin-right: ", "px;\n  "])), -ICON_HORIZONTAL_PADDING));
var StyledLabelText = styled(Text12)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  ", "\n"])), media.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    /* It is intentionally hidden on md screens,\n       as we can't fit it there (see Zeplin) */\n    display: none;\n  "]))));
/**
 * Renders a <LeftBackButton /> component
 * @param {string} label - set the label on the element
 * @param {boolean} labelVisible - an optional param - does label should be visible
 * @param {React.ComponentType} Icon - an optional param - set the Icon on
 * @param {boolean} hidden - set the hidden property on the element
 * @param {string} className - an optional param - set the class on the element
 * @param {void} onClick - an optional param - add the event listener on the element
 **/

var LeftBackButton = function LeftBackButton(_ref) {
  var _ref$labelVisible = _ref.labelVisible,
      labelVisible = _ref$labelVisible === void 0 ? false : _ref$labelVisible,
      _ref$Icon = _ref.Icon,
      Icon = _ref$Icon === void 0 ? BackIcon : _ref$Icon,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": LeftBackButton.selector(props.label),
    tabIndex: props.hidden ? -1 : 0,
    title: labelVisible ? undefined : props.label,
    "aria-label": labelVisible ? props.label : undefined,
    onClick: props.onClick,
    className: className
  }, /*#__PURE__*/React.createElement(Icon, {
    height: 25
  }), labelVisible && /*#__PURE__*/React.createElement(StyledLabelText, null, props.label));
};

LeftBackButton.selector = function (label) {
  return "LeftBackButton:".concat(label);
};

export { ICON_HORIZONTAL_PADDING, LeftBackButton };
